import {
    ADD_CLIENT_REQUESTED,
    ADD_CLIENT_SUCCESS,
    GET_COUNTRY_REQUESTED,
    GET_COUNTRY_SUCCESS,
    GET_COUNTRY_FAILED,
    CLEAR_CONDITION_SUCCESS,
    CLIENT_FAILED,
} from './actionTypes'

export const addClient = (form, state, trigger) => ({
    type: ADD_CLIENT_REQUESTED,
    form,
    state,
    trigger
})

export const addClientSuccess = payload => ({
    type: ADD_CLIENT_SUCCESS,
    payload,
})

export const getCountry = payload => ({
    type: GET_COUNTRY_REQUESTED,
    payload
})

export const getCountrySuccess = payload => ({
    type: GET_COUNTRY_SUCCESS,
    payload,
})

export const getCountryFailed = payload => ({
    type: GET_COUNTRY_FAILED,
    payload,
})

export const returnFailed = payload => ({
    type: CLIENT_FAILED,
    payload,
})

export const clearCondition = () => ({ type: CLEAR_CONDITION_SUCCESS })